import GridColumn from './GridColumn.component';

export default GridColumn;